var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg32IconButtonListV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2254",
    "data-name": "Group 2254",
    transform: "translate(-91 -65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2303",
    "data-name": "Rectangle 2303",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(91 65)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2178",
    "data-name": "Group 2178",
    transform: "translate(102.072 70.93)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 13.706,
    transform: "translate(0.106 13.07)",
    fill: "none",
    stroke: "#7d6a2d",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 13.706,
    transform: "translate(0.106 7)",
    fill: "none",
    stroke: "#7d6a2d",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    x1: 0.089,
    transform: "translate(-3.955 13.07)",
    fill: "none",
    stroke: "#7d6a2d",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    "data-name": "Line 116",
    x1: 0.089,
    transform: "translate(-3.955 7)",
    fill: "none",
    stroke: "#7d6a2d",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg32IconButtonListV2);
export default __webpack_public_path__ + "static/media/32-icon-button-list-v2.71d09b64.svg";
export { ForwardRef as ReactComponent };